import { SIGN_OUT, USER } from '../actions/constants';

const initialState = {
  authorized: false,
};

export default function user(state = initialState, action) {
  const { type, ...rest } = action;

  switch (type) {
    case USER.handlers.signOut:
      return {
        authorized: true,
      };
    case USER.handlers.update:
    case USER.handlers.unit:
    case USER.update:
      return {
        ...state,
        ...rest,
        authorized: true,
        handling: false,
      };
    case USER.unit:
      return {
        ...state,
        collabUnit: {
          ...(state?.collabUnit ?? {}),
          ...rest,
        },
        handling: false,
      };
    case SIGN_OUT:
      return { authorized: true };
    default:
      return state;
  }
}
